/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desktop_Banner_Download_ButtonInputs */



/**
* | output |
* | --- |
* | "Download Desktop App" |
*
* @param {Desktop_Banner_Download_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const desktop_banner_download_button = /** @type {((inputs?: Desktop_Banner_Download_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Banner_Download_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Télécharger l'Application de Bureau")
	if (locale === "de") return /** @type {LocalizedString} */ ("Desktop-App herunterladen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scarica l'app desktop")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скачать настольное приложение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargar la aplicación de escritorio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下载桌面应用程序")
	if (locale === "ja") return /** @type {LocalizedString} */ ("デスクトップアプリをダウンロード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डेस्कटॉप ऐप डाउनलोड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Baixe o aplicativo para desktop")
	return /** @type {LocalizedString} */ ("Download Desktop App")
});